import React, { useEffect, useRef, useState } from 'react';
import { useProgressContext } from '../../ContextProvider/ProgressContext';
import uojApi from '../../Common/Api/uojApi';
import 'remixicon/fonts/remixicon.css';
import ProgressBar from '../ProgressBar/ProgressBar';

const FormCard = () => {
  const { setActiveState, getActiveState } = useProgressContext();
  const [formData, setFormData] = useState({
    name: '',
    voucherPart1: '',
    voucherPart2: '',
    identityNumber: '',
    documentType: 'Passport/NIC',
    phoneCountryCode: '+94', // Default country code (Sri Lanka)
    phoneNumber: '',
    payamount: null,
  });

  const [isCountryCodeDropdownOpen, setIsCountryCodeDropdownOpen] = useState(false);

  // List of country codes for the dropdown
  
  const countryCodes = [
    { code: '+93', country: 'Afghanistan' },
    { code: '+355', country: 'Albania' },
    { code: '+213', country: 'Algeria' },
    { code: '+376', country: 'Andorra' },
    { code: '+244', country: 'Angola' },
    { code: '+1268', country: 'Antigua and Barbuda' },
    { code: '+54', country: 'Argentina' },
    { code: '+374', country: 'Armenia' },
    { code: '+61', country: 'Australia' },
    { code: '+43', country: 'Austria' },
    { code: '+994', country: 'Azerbaijan' },
    { code: '+1242', country: 'Bahamas' },
    { code: '+973', country: 'Bahrain' },
    { code: '+880', country: 'Bangladesh' },
    { code: '+1246', country: 'Barbados' },
    { code: '+375', country: 'Belarus' },
    { code: '+32', country: 'Belgium' },
    { code: '+501', country: 'Belize' },
    { code: '+229', country: 'Benin' },
    { code: '+975', country: 'Bhutan' },
    { code: '+591', country: 'Bolivia' },
    { code: '+387', country: 'Bosnia and Herzegovina' },
    { code: '+267', country: 'Botswana' },
    { code: '+55', country: 'Brazil' },
    { code: '+673', country: 'Brunei' },
    { code: '+359', country: 'Bulgaria' },
    { code: '+226', country: 'Burkina Faso' },
    { code: '+257', country: 'Burundi' },
    { code: '+855', country: 'Cambodia' },
    { code: '+237', country: 'Cameroon' },
    { code: '+1', country: 'Canada' },
    { code: '+238', country: 'Cape Verde' },
    { code: '+236', country: 'Central African Republic' },
    { code: '+235', country: 'Chad' },
    { code: '+56', country: 'Chile' },
    { code: '+86', country: 'China' },
    { code: '+57', country: 'Colombia' },
    { code: '+269', country: 'Comoros' },
    { code: '+242', country: 'Congo' },
    { code: '+243', country: 'Congo (Democratic Republic)' },
    { code: '+506', country: 'Costa Rica' },
    { code: '+225', country: 'Côte d\'Ivoire' },
    { code: '+385', country: 'Croatia' },
    { code: '+53', country: 'Cuba' },
    { code: '+357', country: 'Cyprus' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+45', country: 'Denmark' },
    { code: '+253', country: 'Djibouti' },
    { code: '+1767', country: 'Dominica' },
    { code: '+1809', country: 'Dominican Republic' },
    { code: '+593', country: 'Ecuador' },
    { code: '+20', country: 'Egypt' },
    { code: '+503', country: 'El Salvador' },
    { code: '+240', country: 'Equatorial Guinea' },
    { code: '+291', country: 'Eritrea' },
    { code: '+372', country: 'Estonia' },
    { code: '+268', country: 'Eswatini' },
    { code: '+251', country: 'Ethiopia' },
    { code: '+679', country: 'Fiji' },
    { code: '+358', country: 'Finland' },
    { code: '+33', country: 'France' },
    { code: '+241', country: 'Gabon' },
    { code: '+220', country: 'Gambia' },
    { code: '+995', country: 'Georgia' },
    { code: '+49', country: 'Germany' },
    { code: '+233', country: 'Ghana' },
    { code: '+30', country: 'Greece' },
    { code: '+1473', country: 'Grenada' },
    { code: '+502', country: 'Guatemala' },
    { code: '+224', country: 'Guinea' },
    { code: '+245', country: 'Guinea-Bissau' },
    { code: '+592', country: 'Guyana' },
    { code: '+509', country: 'Haiti' },
    { code: '+504', country: 'Honduras' },
    { code: '+852', country: 'Hong Kong' },
    { code: '+36', country: 'Hungary' },
    { code: '+354', country: 'Iceland' },
    { code: '+91', country: 'India' },
    { code: '+62', country: 'Indonesia' },
    { code: '+98', country: 'Iran' },
    { code: '+964', country: 'Iraq' },
    { code: '+353', country: 'Ireland' },
    { code: '+972', country: 'Israel' },
    { code: '+39', country: 'Italy' },
    { code: '+1876', country: 'Jamaica' },
    { code: '+81', country: 'Japan' },
    { code: '+962', country: 'Jordan' },
    { code: '+7', country: 'Kazakhstan' },
    { code: '+254', country: 'Kenya' },
    { code: '+686', country: 'Kiribati' },
    { code: '+965', country: 'Kuwait' },
    { code: '+996', country: 'Kyrgyzstan' },
    { code: '+856', country: 'Laos' },
    { code: '+371', country: 'Latvia' },
    { code: '+961', country: 'Lebanon' },
    { code: '+266', country: 'Lesotho' },
    { code: '+231', country: 'Liberia' },
    { code: '+218', country: 'Libya' },
    { code: '+423', country: 'Liechtenstein' },
    { code: '+370', country: 'Lithuania' },
    { code: '+352', country: 'Luxembourg' },
    { code: '+853', country: 'Macau' },
    { code: '+261', country: 'Madagascar' },
    { code: '+265', country: 'Malawi' },
    { code: '+60', country: 'Malaysia' },
    { code: '+960', country: 'Maldives' },
    { code: '+223', country: 'Mali' },
    { code: '+356', country: 'Malta' },
    { code: '+692', country: 'Marshall Islands' },
    { code: '+222', country: 'Mauritania' },
    { code: '+230', country: 'Mauritius' },
    { code: '+52', country: 'Mexico' },
    { code: '+691', country: 'Micronesia' },
    { code: '+373', country: 'Moldova' },
    { code: '+377', country: 'Monaco' },
    { code: '+976', country: 'Mongolia' },
    { code: '+382', country: 'Montenegro' },
    { code: '+212', country: 'Morocco' },
    { code: '+258', country: 'Mozambique' },
    { code: '+95', country: 'Myanmar' },
    { code: '+264', country: 'Namibia' },
    { code: '+674', country: 'Nauru' },
    { code: '+977', country: 'Nepal' },
    { code: '+31', country: 'Netherlands' },
    { code: '+64', country: 'New Zealand' },
    { code: '+505', country: 'Nicaragua' },
    { code: '+227', country: 'Niger' },
    { code: '+234', country: 'Nigeria' },
    { code: '+850', country: 'North Korea' },
    { code: '+389', country: 'North Macedonia' },
    { code: '+47', country: 'Norway' },
    { code: '+968', country: 'Oman' },
    { code: '+92', country: 'Pakistan' },
    { code: '+680', country: 'Palau' },
    { code: '+970', country: 'Palestine' },
    { code: '+507', country: 'Panama' },
    { code: '+675', country: 'Papua New Guinea' },
    { code: '+595', country: 'Paraguay' },
    { code: '+51', country: 'Peru' },
    { code: '+63', country: 'Philippines' },
    { code: '+48', country: 'Poland' },
    { code: '+351', country: 'Portugal' },
    { code: '+974', country: 'Qatar' },
    { code: '+40', country: 'Romania' },
    { code: '+7', country: 'Russia' },
    { code: '+250', country: 'Rwanda' },
    { code: '+1869', country: 'Saint Kitts and Nevis' },
    { code: '+1758', country: 'Saint Lucia' },
    { code: '+1784', country: 'Saint Vincent and the Grenadines' },
    { code: '+685', country: 'Samoa' },
    { code: '+378', country: 'San Marino' },
    { code: '+239', country: 'São Tomé and Príncipe' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+221', country: 'Senegal' },
    { code: '+381', country: 'Serbia' },
    { code: '+248', country: 'Seychelles' },
    { code: '+232', country: 'Sierra Leone' },
    { code: '+65', country: 'Singapore' },
    { code: '+421', country: 'Slovakia' },
    { code: '+386', country: 'Slovenia' },
    { code: '+677', country: 'Solomon Islands' },
    { code: '+252', country: 'Somalia' },
    { code: '+27', country: 'South Africa' },
    { code: '+82', country: 'South Korea' },
    { code: '+211', country: 'South Sudan' },
    { code: '+34', country: 'Spain' },
    { code: '+94', country: 'Sri Lanka' },
    { code: '+249', country: 'Sudan' },
    { code: '+597', country: 'Suriname' },
    { code: '+46', country: 'Sweden' },
    { code: '+41', country: 'Switzerland' },
    { code: '+963', country: 'Syria' },
    { code: '+886', country: 'Taiwan' },
    { code: '+992', country: 'Tajikistan' },
    { code: '+255', country: 'Tanzania' },
    { code: '+66', country: 'Thailand' },
    { code: '+670', country: 'Timor-Leste' },
    { code: '+228', country: 'Togo' },
    { code: '+676', country: 'Tonga' },
    { code: '+1868', country: 'Trinidad and Tobago' },
    { code: '+216', country: 'Tunisia' },
    { code: '+90', country: 'Turkey' },
    { code: '+993', country: 'Turkmenistan' },
    { code: '+688', country: 'Tuvalu' },
    { code: '+256', country: 'Uganda' },
    { code: '+380', country: 'Ukraine' },
    { code: '+971', country: 'United Arab Emirates' },
    { code: '+44', country: 'United Kingdom' },
    { code: '+1', country: 'United States' },
    { code: '+598', country: 'Uruguay' },
    { code: '+998', country: 'Uzbekistan' },
    { code: '+678', country: 'Vanuatu' },
    { code: '+379', country: 'Vatican City' },
    { code: '+58', country: 'Venezuela' },
    { code: '+84', country: 'Vietnam' },
    { code: '+967', country: 'Yemen' },
    { code: '+260', country: 'Zambia' },
    { code: '+263', country: 'Zimbabwe' }
  ];


  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [user, setUser] = useState({
    name: '',
    purpose: '',
    total: '',
  });


  const [isVoucherValid, setIsVoucherValid] = useState(true); //form validation
  const [authvoucher, setAuthVoucher] = useState(false); //after verified voucher state
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const active = getActiveState();
 
  const [aid, setAid] = useState(active.id);
  const [errors, setErrors] = useState({});
  
  useEffect(() => {
    setAid(active.id);
   
  }, [active]);

  useEffect(() => {
    setActiveState(1); // This will override the reset
  }, []);


  const payamountRef = useRef();

  // post api call for 1 st stage
 const checkvoucher = async (vouchercode) => {
  try {
    
    const response = await uojApi.post(
      `/voucher-verify?voucher_code=${vouchercode}`
    );
    
    // Check if the response indicates a valid voucher
    if (response.data.message === "This is a valid voucher code") {
      setAuthVoucher(true);
      setError(null);
      setSuccess(response.data.message);
      setUser({
        name: response.data.data.user_name,
        purpose: response.data.data.voucher,
        total: response.data.data.amount,
      });
    } else {
      // Handle case where voucher is not valid but request was successful
      setError(response.data.message);
      setSuccess(null);
      setAuthVoucher(false);
    }
  } catch (error) {
    setError(error.response?.data?.message || "Error verifying voucher");
    setSuccess(null);
    setAuthVoucher(false);
    console.error('Error while verifying voucher', error);

    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    }
  }
};

  
 const handleChange = (e) => {
  const { name, value } = e.target;

  // Special handling for phone number to accept only numbers
  if (name === "phoneNumber") {
    // Only allow digits
    if (value !== "" && !/^\d+$/.test(value)) {
      return; // Ignore non-numeric input
    }
  }

  if (name === "payamount") {
    // Allow only positive integers, prevent leading zeros
    if (
      value &&
      !/^(0|[1-9]\d*)(\.\d{0,2})?$/.test(value)
    ) {
      return; // Ignore invalid input
    }

    // Validate only if user.total is defined
    if (user?.total && parseFloat(value) > user.total) {
      setErrors({
        ...errors,
        payamount: `Pay amount cannot exceed Total Amount (${user.total}).`,
      });
      return;
    }

    // Clear errors if input is valid
    setErrors({ ...errors, payamount: "" });
  }

  setFormData({ ...formData, [name]: value });
  setIsDropdownOpen(false);
};

// Handle country code selection
  const handleCountryCodeSelect = (code) => {
    setFormData({ ...formData, phoneCountryCode: code });
    setIsCountryCodeDropdownOpen(false);
  };



  const handleVerify = () => {
  // Combine voucherPart1 and voucherPart2 to form the full voucher code
  const voucherCode = `${formData.voucherPart1}${formData.voucherPart2}`;

  // Check if the combined voucher code is 16 digits and numeric
  const isNumeric = /^[0-9]+$/.test(voucherCode);
  if (voucherCode.length === 16 && isNumeric) {
    setIsVoucherValid(true);
    checkvoucher(voucherCode); // Pass the full voucher code to the checkvoucher function
  } else {
    setIsVoucherValid(false);
  }
};

  const handleClear = () => {
    setFormData({
      name: '',
      voucherPart1: '',
      voucherPart2: '',
      identityNumber: '',
      documentType: 'Passport/NIC',
      phoneCountryCode: '+94',
      phoneNumber: '',
      payamount: null, 
    });
    setSuccess(null);
    setError(null);
    setIsVoucherValid(true);
    setAuthVoucher(false);
    setErrors({});
  };



  const handleBack = () => {
    const activeState = getActiveState();
    if (activeState && activeState.id < 3) {
      setActiveState(activeState.id - 1);
    }
  };
 


const [payNowClicked, setPayNowClicked] = useState(false); // Track Pay Now button click

  // Function to fetch the payment form using uojApi
  useEffect(() => {
    const fetchPaymentForm = async () => {
      try {
        console.log("Sending payment data:", formData);

        // Sending POST request with payment data using uojApi
        const response = await uojApi.post(
          "/payment", // API endpoint for payment
          {
            amount: formData.payamount,
            identity_number: formData.identityNumber,
            identity_type: formData.documentType,
            payee_name: formData.name,
            voucher_code: `${formData.voucherPart1}${formData.voucherPart2}`,
            phone_number: `${formData.phoneCountryCode}${formData.phoneNumber}`, // Combine country code and phone number
            
          }
        );

        // Check if the response data is valid and contains a form
        if (response.data && response.data.data) {
          const formHTML = response.data.data.form; // Get the HTML form as a string
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = formHTML; // Set the HTML content inside a temporary div

          // Extract the form element from the HTML string
          const form = tempDiv.querySelector("form");
          if (form) {
            // Append form to the body and submit it
            document.body.appendChild(form);
            form.submit(); // Automatically submit the form
          } else {
            console.error("Form element not found in the response.");
          }
        }
   
      } catch (error) {
        // Handle errors and display an alert
        console.error("Error fetching payment form:", error);
        alert("Error fetching the payment form.");
      }
    };

   

    // Ensure fetchPaymentForm is called only when Pay Now is clicked and formData is valid
    if (payNowClicked) {
      if (
        formData.payamount &&
        formData.identityNumber &&
        formData.documentType &&
        formData.name &&
        formData.phoneNumber &&
        `${formData.voucherPart1}${formData.voucherPart2}`
      ) {
        fetchPaymentForm();
      } else {
        alert("Please fill in all required fields.");
      }
      setPayNowClicked(false); // Reset the state to prevent repeated API calls
    }

  
  }, [payNowClicked, formData]); // Runs when payNowClicked or formData changes

   

  // Handle the "Pay Now" button click
  const handlePayNowClick = () => {
    setPayNowClicked(true);  
  };

  const handleNext = () => {
  const handleValidation = () => {
    let isValid = true;
    let errorMsg = {};

    // Validate Voucher Code
    // Validate Voucher Code (Part 1 and Part 2)
    if (!formData.voucherPart1 || formData.voucherPart1.length !== 8) {
      isValid = false;
      errorMsg.voucherPart1 = "Voucher part 1 must be an 8-digit code.";
    }
    if (!formData.voucherPart2 || formData.voucherPart2.length !== 8) {
      isValid = false;
      errorMsg.voucherPart2 = "Voucher part 2 must be an 8-digit code.";
    }

    // Validate Name
    if (!formData.name.trim()) {
      isValid = false;
      errorMsg.name = "Name is required.";
    }

    // Validate Document Type
    if (!formData.documentType) {
      isValid = false;
      errorMsg.documentType = "Identity type is required.";
    }

    // Validate Identity Number
    if (formData.documentType === "NIC") {
      const nicRegexOld = /^[0-9]{9}[vVxX]$/; // e.g., 123456789V
      const nicRegexNew = /^[0-9]{12}$/; // e.g., 200123456789
      if (
        !formData.identityNumber.match(nicRegexOld) &&
        !formData.identityNumber.match(nicRegexNew)
      ) {
        isValid = false;
        errorMsg.identityNumber = "Invalid NIC format.";
      }
    } else if (formData.documentType === "Passport") {
      const passportRegex = /^[A-Z0-9]{7,10}$/; // e.g., AB1234567
      if (!formData.identityNumber.match(passportRegex)) {
        isValid = false;
        errorMsg.identityNumber = "Invalid Passport format.";
      }
    } else {
      isValid = false;
      errorMsg.identityNumber = "Identity type is required.";
    }

    // Validate Phone Number
    if (!formData.phoneNumber.trim()) {
      isValid = false;
      errorMsg.phoneNumber = "Phone number is required.";
    } else if (!/^\d+$/.test(formData.phoneNumber)) {
      isValid = false;
      errorMsg.phoneNumber = "Phone number must contain only digits.";
    } else {
      // Check for a reasonable phone number length based on country code
      const minLength = 6;
      const maxLength = 15;
      
      if (formData.phoneNumber.length < minLength || formData.phoneNumber.length > maxLength) {
        isValid = false;
        errorMsg.phoneNumber = `Phone number should be between ${minLength} and ${maxLength} digits.`;
      }
    }

          // ✅ Validate Pay Amount (integer or decimal)
      if (
        !formData.payamount ||
        !/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(formData.payamount)
      ) {
        isValid = false;
        errorMsg.payamount = "Please enter a valid Pay Amount.";
      }

    setErrors(errorMsg);
    return isValid;
  };

  if (handleValidation()) {
    console.log("All fields are valid. Proceeding to next stage...");
    const activeState = getActiveState();
    if (activeState && activeState.id < 3) {
      setActiveState(activeState.id + 1);
    }
  } else {
    console.log("Validation failed. Please check the errors.");
  }
};


  return (
    <div className='flex  items-center justify-center my-12   '>
      <div className='bg-white text-sm lg:text-[16px] text-black rounded-md   border-2 border-gray-100  shadow-lg p-4 md:p-6 md:w-[60%] lg:w-[50%]'>
        <h1 className='mb-0 text-xl lg:text-[22px] text-blue-900 font-semibold tracking-widest uppercase' style={{ textShadow: '' }}>Pay Online</h1>
        <ProgressBar/>

        {/* 1st stage */}
        {aid === 1 && (
          <>
            <div className='sm:mb-8  mb-6'>
              <div className='sm:mb-8 mb-6 '>
                <div className='flex flex-col sm:flex-row gap-2'>
                  <div className='flex-1 min-w-0'>
                    <label htmlFor="voucherPart1" className='block text-sm font-medium text-gray-700 mb-1 text-left'>
                      Payee / Student Code <span className='text-red-600 font-semibold '>* </span> 
                    </label>
                    <input
                        className="w-full px-3 py-2 border rounded-l"
                        type="text"
                        id="voucherPart1"
                        name="voucherPart1"
                        placeholder="⁠Eg: XXXXXXXX"
                        value={formData.voucherPart1}
                        onChange={handleChange}
                        maxLength={8}
                        required
                      />
                  </div>
                  <div className='flex-1 min-w-0'>
                    <label htmlFor="voucherPart2" className='block text-sm font-medium text-gray-700 mb-1 text-left'>
                      Payment Code <span className='text-red-600 font-semibold '>* </span> 
                    </label>
                    <input
                        className="w-full px-3 py-2 border"
                        type="text"
                        id="voucherPart2"
                        name="voucherPart2"
                        placeholder="⁠Eg: XXXXXXXX"
                        value={formData.voucherPart2}
                        onChange={handleChange}
                        maxLength={8}
                        required
                      />
                  </div>
                  <div className='flex items-end sm:items-end'>
                    <button
                      className="bg-blue-500 text-white px-4 py-2 rounded whitespace-nowrap"
                      onClick={handleVerify}
                    >
                      Verify
                    </button>
                  </div>
                </div>
                {errors.voucherPart1 && (
                  <p className='text-red-500'>{errors.voucherPart1}</p>
                )}
                {errors.voucherPart2 && (
                  <p className='text-red-500'>{errors.voucherPart2}</p>
                )}
                {!isVoucherValid && (
                  <p className='text-red-500'>
                    Voucher code must be a 16-digit number.
                  </p>
                )}
                {error && <p className='text-red-500'>{error}</p>}
                {authvoucher && success && (
                 <div className="flex flex-col items-start sm:p-6 p-2 bg-blue-500 bg-opacity-10 shadow-xl rounded-lg w-full lg:w-4/5 sm:mx-auto mx-1 mt-4 sm:mt-4">
                    <h1 className="sm:text-[16px] text-[14px] font-semibold text-gray-700 mb-2 tracking-wide">Student Details</h1>

                      <div className="space-y-1 w-full">
                        <div className="sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  selection: text-gray-700">
                          <span>User Name:</span>
                          <span className="text-blue-600 font-normal">{user.name}</span>
                        </div>

                        <div className="sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700">
                          <span>Fee Type: </span>
                          <span className="text-blue-600 font-normal">{user.purpose}</span>
                        </div> 
                        

                        <div className="sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700">
                          <span>Total Amount: </span>
                          <span className="text-blue-600 font-normal">{user.total}</span>
                        </div>
                      </div>
                    </div>
              )}
              </div>

              
              <div>
              <label htmlFor="payeename" className='block text-sm font-medium text-gray-700 mb-1 text-left'>
              Payee Full Name <span className='text-red-600 font-semibold '>* </span> 
              </label>
               <input
                className="w-full px-3 py-2 border rounded"
                type="text"
                id="name"
                name="name"
                placeholder="Eg: ABC XYZ"
                value={formData.name}
                onChange={handleChange}
                required
               />
              {errors.name && <p className="text-red-500 mt-1">{errors.name}</p>}
              </div>

            </div>

              <div className="sm:mb-8 mb-6">
                <div className="flex sm:gap-4 gap-2">
                  {/* Document Type Dropdown */}
                  <div className="flex-1">
                    <label 
                      htmlFor="documentType" 
                      className="block text-sm font-medium text-gray-700 mb-1 text-left"
                    >
                      Identity Type <span className='text-red-600 font-semibold '>* </span> 
                    </label>
                    <div className="relative">
                      <div
                        className="px-3 py-2 border border-gray-300 rounded-md cursor-pointer text-left bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        {formData.documentType || "Select document type"}
                        <span className="float-right">▼</span>
                      </div>
                      {isDropdownOpen && (
                        <div className="absolute left-0 top-full bg-white border border-gray-300 rounded-md shadow-lg w-full z-10 mt-1">
                          <div
                            className="p-2 cursor-pointer hover:bg-blue-50 border-b border-gray-100"
                            onClick={() => {
                              handleChange({ target: { name: "documentType", value: "NIC" } });
                              setIsDropdownOpen(false);
                            }}
                          >
                            National ID Card (NIC)
                          </div>
                          <div
                            className="p-2 cursor-pointer hover:bg-blue-50"
                            onClick={() => {
                              handleChange({ target: { name: "documentType", value: "Passport" } });
                              setIsDropdownOpen(false);
                            }}
                          >
                            Passport
                          </div>
                        </div>
                      )}
                    </div>
                    {errors.documentType && (
                      <p className="text-red-500 text-sm mt-1">{errors.documentType}</p>
                    )}
                  </div>

                  {/* Identity Number Input */}
                  <div className="flex-1">
                    <label 
                      htmlFor="identityNumber" 
                      className="block text-sm font-medium text-gray-700 mb-1 text-left"
                    >
                      Identity Number <span className='text-red-600 font-semibold '>* </span> 
                    </label>
                    <input
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      type="text"
                      id="identityNumber"
                      name="identityNumber"
                      placeholder={formData.documentType === "Passport" ? "Eg: NXXXXXXX" : "Eg: XXXXXXXXXXXX"}
                      value={formData.identityNumber}
                      onChange={handleChange}
                      required
                    />
                    {errors.identityNumber && (
                      <p className="text-red-500 text-sm mt-1">{errors.identityNumber}</p>
                    )}
                  </div>
                </div>
              </div>


            {/* Phone Number with Country Code */}
            <div className="sm:mb-8 mb-6">
              <label htmlFor="mobile no" className='block text-sm font-medium text-gray-700 mb-1 text-left'>
              Mobile Number <span className='text-red-600 font-semibold '>* </span> 
              </label>
              <div className="flex gap-2">
                {/* Country Code Dropdown */}
                <div className="relative">
                  <div
                    className="px-3 py-2 border rounded cursor-pointer w-20 text-center bg-blue-100"
                    onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}
                  >
                    {formData.phoneCountryCode}
                  </div>
                  {isCountryCodeDropdownOpen && (
                    <div className="absolute left-0 top-full bg-white border rounded shadow-md w-48 max-h-60 overflow-y-auto z-20">
                      {countryCodes.map((country, index) => (
                        <div
                          key={index}
                          className="p-2 cursor-pointer hover:bg-blue-200 flex justify-between"
                          onClick={() => handleCountryCodeSelect(country.code)}
                        >
                          <span>{country.country}</span>
                          <span className="font-semibold">{country.code}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                
                
                <input
                  className="flex-grow px-3 py-2 border rounded"
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Eg: 07XXXXXXXX"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>
              {errors.phoneNumber && <p className="text-red-500 mt-1">{errors.phoneNumber}</p>}
            </div>


          <div className="sm:mb-8 mb-6 relative">
          <label 
            htmlFor="payamount" 
            className="block text-sm font-medium text-gray-700 mb-1 text-left"
          >
            Payment Amount (LKR) <span className='text-red-600 font-semibold '>* </span> 
          </label>

              {/* LKR prefix */}
                  <div className="relative">
                                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium">
                                  LKR
                                </span>

                {/* Input field with padding-left so text does not overlap LKR */}
                <input
                  className="w-full pl-12 pr-3 py-2 border rounded"
                  ref={payamountRef}
                  type="text"
                  id="payamount"
                  name="payamount"
                  placeholder="0.00"
                  value={formData.payamount || ''} 
                  onChange={handleChange}
                  required
                />
                </div>

                {errors.payamount && <p className="text-red-500 mt-1">{errors.payamount}</p>}
              </div>



         
            <div className='flex justify-between'>
              <button
                className='bg-red-500 text-white px-4 py-2 rounded shadow-lg'
                onClick={handleClear}
              >
                Clear
              </button>
              <button
                className={`bg-blue-500 text-white px-4 py-2 rounded shadow-xl ${
                  !authvoucher ? 'bg-gray-200' : null
                }`}
                disabled={!authvoucher}
                onClick={handleNext}
              >
                Next
              </button>
            </div>
          </>
        )}
        {/* end of first stage */}
 

        {/* end of 2nd stage */}

        {/* 3rd Stage */}
        {aid === 2 && (
          <>
            <div className='sm:mb-8 mb-6'>
            {/* Student Details Section */}
            <div className='mx-1 md:mx-8'>
            <div className='flex flex-col items-start shadow-lg p-4 bg-blue-500 bg-opacity-10 rounded-lg'>
            <h1 className='font-bold text-gray-700 lg:text-[17px] text-[14px] tracking-wide mb-4'>Student Details</h1>

            <div className='space-y-1 w-full'>
              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700'>
                <span>User Name: </span>
                <span className='text-blue-600 font-normal'>{user.name}</span>
              </div>

              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700'>
                <span>Fee Type: </span>
                <span className='text-blue-600 font-normal'>{user.purpose}</span>
              </div>

              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700'>
                <span>Total Amount: </span>
                <span className='text-blue-600 font-normal'>{user.total}</span>
              </div>

              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700'>
                <span>Voucher Code: </span>
                <span className='text-blue-600 font-normal'>{`${formData.voucherPart1}${formData.voucherPart2}`}</span>
              </div>
            </div>
          </div>

          {/* Payer Details Section */}
          <div className='flex flex-col items-start sm:mt-8 mt-6 shadow-lg p-4 bg-blue-500 bg-opacity-10  rounded-lg'>
            <h1 className='font-bold text-gray-700 lg:text-[17px] text-[14px] tracking-wide mb-4'>Payer Details</h1>

            <div className='space-y-1 w-full'>
              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]   text-gray-700'>
                <span>Name: </span>
                <span className='text-blue-600 font-normal'>{formData.name}</span>
              </div>

              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700'>
                <span>{formData.documentType}: </span>
                <span className='text-blue-600 font-normal'>{formData.identityNumber}</span>
              </div>

              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700'>
                <span>Paying Amount: </span>
                <span className='text-blue-600 font-normal'>{parseFloat(formData.payamount).toFixed(2)}</span>
              </div>

              <div className='sm:flex sm:justify-between text-start lg:text-[16px] text-[14px]  text-gray-700'>
                <span>Phone No: </span>
                <span className='text-blue-600 font-normal'>{`${formData.phoneCountryCode} ${formData.phoneNumber}`}</span>
              </div>
            </div>
          </div>
        </div>
        </div>


        {/* ✅ Card payment note */}
        <div className="mx-1 md:mx-8 mt-4">
          <div className="bg-yellow-50 border border-yellow-300 text-yellow-800 text-sm rounded-md p-3">
            <span className="font-semibold">Note:</span>{' '}
            Kindly note that card payments are subject to an additional{' '}
            <span className="font-semibold">1%</span> processing fee.
          </div>
        </div>

        {/* Buttons */}
        <div className='flex justify-between mt-6'>
          <button
            className='bg-red-500 text-white px-4 py-2 rounded shadow-lg'
            onClick={handleBack}
          >
            Back
          </button>
          <button
            className='bg-blue-500 text-white px-4 py-2 rounded shadow-xl'
            onClick={handlePayNowClick}
          >
            Pay Now
          </button>
        </div>
      </>
    )}

             {/* <div className='flex justify-between'>
              <button
                className='bg-red-500 text-white px-4 py-2 rounded shadow-lg'
                onClick={handleBack}
              >
                Back
              </button>
              <button
                className='bg-blue-500 text-white px-4 py-2 rounded shadow-xl'
                onClick={handlePayNowClick}
              >
                Pay Now
              </button>
            </div>
          </>
        )} 
          */}
       

        {/*4rd Stage */}
        {aid === 3 && (
        <>
          <h1>Redirecting to Payment Gateway...</h1>
        </>
        )}
      </div>
    </div>
  );
};

export default FormCard;